import { useCallback, useState } from 'react';

type ToggleApi = {
  value: boolean;
  toggle: () => void;
  toggleOn: () => void;
  toggleOff: () => void;
};

export function useToggle(initialValue = false): ToggleApi {
  const [value, setValue] = useState(initialValue);
  const toggle = useCallback(() => {
    setValue((value) => !value);
  }, []);
  const toggleOn = useCallback(() => {
    setValue(true);
  }, []);
  const toggleOff = useCallback(() => {
    setValue(false);
  }, []);
  return { value, toggle, toggleOn, toggleOff };
}
